import { useNavigate } from 'react-router-dom';

import JourneyCards from '../../../../../components/JourneyCards';
import { STORY_SECTION } from './constants';
import { clientJourney } from '../../constants';

import { JourneySection, JourneyContainer, JourneyTitle, JourneyButtonContainer } from './styles';
import CTAButton from '../../../../../ui/ctaButton';
const StorySection = () => {
  const navigate = useNavigate();

  const handleExploreServicesClick = () => {
    navigate('/services');
  };

  return (
    <JourneySection>
      <JourneyContainer>
        <JourneyTitle variant="caption">{STORY_SECTION.JOURNEY_TITLE}</JourneyTitle>
        <JourneyCards steps={clientJourney} />

        <JourneyButtonContainer>
          <CTAButton
            variant="contained"
            text={STORY_SECTION.BUTTON_LABEL}
            onClick={handleExploreServicesClick}
          />
        </JourneyButtonContainer>
      </JourneyContainer>
    </JourneySection>
  );
};

export default StorySection;
